import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

import { ButtonPrimary } from "../../ui/buttons";

const ConfirmModal = ({ toggle, isOpen, handleContinuar, handleCancelar, title, text, canClose = false }) => {
  return (
    <div>
      <Modal isOpen={isOpen} centered style={{ fontFamily: "Nunito" }}>
        {canClose && <ModalHeader toggle={toggle} className="border-0 pb-1" style={{ background: " #f8f8f8", borderRadius: "4px 4px 0px 0px" }} />}
        <ModalBody className="pt-3 px-2" style={{ alignItems: "center !important", background: " #f8f8f8", borderRadius: "4px 4px 0px 0px" }}>
          <h4 className="m-y mt-4 text-center" style={{ fontSize: "22px" }}>
            {title}
          </h4>
          <p className="mx-3 text-center">{text}</p>
        </ModalBody>
        <ModalFooter style={{ background: "#f8f8f8", borderTop: "none", borderRadius: "0px 0px 4px 4px" }}>
          <div className=" mt-3 mb-0 d-flex justify-content-end">
            <Button type="button" color="btn-secondary mr-2" onClick={handleCancelar ? () => handleCancelar() : () => toggle()}>
              Cancelar
            </Button>
            <ButtonPrimary type="button" onClick={handleContinuar ? () => handleContinuar() : () => toggle()}>
              Continuar
            </ButtonPrimary>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ConfirmModal;
